import { all } from 'redux-saga/effects';
import { watchParseData } from './sdmx/data';
import { chartSaga } from './chart';

export default function* rootSaga() {
  yield all([watchParseData(), chartSaga()]);
}
